import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f20ec60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "cropper-img" }
const _hoisted_3 = { class: "cropper-img__conponent" }
const _hoisted_4 = { class: "cropper-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_uf_form_item = _resolveComponent("uf-form-item")!
  const _component_VuePictureCropper = _resolveComponent("VuePictureCropper")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_uf_form_item, {
      title: _ctx.options.title,
      required: _ctx.options.is_checked == '1',
      "left-content": _ctx.lenInfo,
      readonly: _ctx.disabled
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.options.pic_type == 0)
            ? (_openBlock(), _createBlock(_component_van_uploader, {
                key: 0,
                modelValue: _ctx.fileList,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fileList) = $event)),
                "max-count": _ctx.options.num_max,
                "after-read": _ctx.upload,
                "before-read": _ctx.beforeRead,
                deletable: !_ctx.disabled,
                "show-upload": !_ctx.disabled
              }, null, 8, ["modelValue", "max-count", "after-read", "before-read", "deletable", "show-upload"]))
            : (_openBlock(), _createBlock(_component_van_uploader, {
                key: 1,
                modelValue: _ctx.fileList,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fileList) = $event)),
                "max-count": _ctx.options.num_max,
                "after-read": _ctx.upload,
                "before-read": _ctx.beforeRead,
                deletable: !_ctx.disabled,
                "show-upload": !_ctx.disabled,
                capture: ""
              }, null, 8, ["modelValue", "max-count", "after-read", "before-read", "deletable", "show-upload"]))
        ])
      ]),
      _: 1
    }, 8, ["title", "required", "left-content", "readonly"]),
    _createVNode(_component_van_popup, {
      show: _ctx.cropperInfo.show,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.cropperInfo.show) = $event)),
      teleport: "body",
      style: { height: '100%', width: '100%', background: 'transparent' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_VuePictureCropper, {
              boxStyle: {
            width: '100%',
            height: '100%',
            backgroundColor: 'transparent',
            margin: 'auto'
          },
              img: _ctx.cropperInfo.pic,
              options: {
            minCropBoxWidth: 150,
            viewMode: 1,
            // guides: false,
            cropBoxResizable: true,
            dragMode: 'move',
            aspectRatio: 7 / 10
          }
            }, null, 8, ["img"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("i", {
              class: "cropper-btn__cancel",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cropperInfo.cancel && _ctx.cropperInfo.cancel(...args)))
            }, "取消"),
            _createElementVNode("i", {
              class: "cropper-btn__confirm",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cropperInfo.confirm && _ctx.cropperInfo.confirm(...args)))
            }, "确定")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}